export default __webpack_public_path__ + "static/media/publish.409907e9.svg";